import React, { useEffect, useRef, useState } from 'react'
import ReactModal from 'react-modal'
import { useParams } from 'react-router-dom'
import { toast } from 'react-toastify'
import ShareFormSettingModal from './formBuilderModel/ShareFormSettingModel'
import { Link, useNavigate } from 'react-router-dom'
import ShareOnWhatsAppModel from './formBuilderModel/ShareOnWhatsAppModel'
import ShareViaEmailModel from './formBuilderModel/ShareViaEmailModel'
import QrcodeGenerateModel from './formBuilderModel/QrcodeGenerateModel'
import { useMutation, useQuery } from '@apollo/client'
import {
  GET_ALL_FORM_BUILDER_BY_BG_ACCOUNT_ID,
  GET_DEPENDENT_FORM_DETAILS
} from '../../../graphql/query'
import { ADD_FORM_DEPENDENCY } from '../../../graphql/mutation'
import PrefillDistributionPanel from './formBuilderModel/PrefillDistributionPanel'
import {
  getFormTypeBadgeClass,
  getFormTypeLabel,
  isPrefillDistributionForm
} from './formBuilderModel/formTypeUtils'
const ShareForm = () => {
  const [isCopiedLink, setIsCopiedLink] = useState(false)
  const [selectedAccess, setSelectedAccess] = useState<string | null>('public') // Set initial access
  const linkRef = useRef<HTMLInputElement | null>(null)
  const params = useParams()
  const uuid = params.uuid
  const navigate = useNavigate()
  const [isSelectFieldModalOpen, setIsSelectFieldModalOpen] = useState(false)
  const [selectedFields, setSelectedFields] = useState<string[]>([])

  const [isModalOpen, setIsModalOpen] = useState<boolean>(false)
  const [qrCodeUrl, setQrCodeUrl] = useState<string>('') // State to store QR code URL
  const [isQrCodeModalOpen, setIsQrCodeModalOpen] = useState(false)
  const [showShareForm, setShowShareForm] = useState(false)
  const [isEmailModelOpen, setIsEmailModelOpen] = useState(false)
  const [isWhatsAppModelOpen, setIsWhatsAppModelOpen] = useState(false)
  const [senderEmail, setSenderEmail] = useState('')
  const [receiverEmail, setReceiverEmail] = useState('')
  const [customMessage, setCustomMessage] = useState('')
  const [formLinkInput, setFormLinkInput] = useState('')
  const [initialFormData, setInitialFormData] = useState({
    senderEmail: '',
    receiverEmail: '',
    customMessage: '',
    formLinkInput: '',
    selectedFields: [] as string[]
  })
  const { loading, error, data } = useQuery(GET_ALL_FORM_BUILDER_BY_BG_ACCOUNT_ID, {
    variables: {
      input: {
        formUuid: uuid
      }
    },
    context: {
      headers: {
        'access-control-allow-methods': 'Form-Builder'
      }
    }
  })

  const {
    loading: loading1,
    error: error1,
    data: data1
  } = useQuery(GET_DEPENDENT_FORM_DETAILS, {
    variables: {
      input: {
        currentFormUuid: uuid
      }
    },
    context: {
      headers: {
        'access-control-allow-methods': 'Form-Builder'
      }
    }
  })

  const [AddFormDependency] = useMutation(ADD_FORM_DEPENDENCY, {
    refetchQueries: [
      {
        query: GET_DEPENDENT_FORM_DETAILS,
        variables: {
          input: {
            currentFormUuid: uuid
          }
        },
        context: {
          headers: {
            'access-control-allow-methods': 'Form-Builder'
          }
        }
      }
    ],
    context: {
      headers: {
        'access-control-allow-methods': 'Form-Builder'
      }
    }
  })

  useEffect(() => {
    if (data1?.getDependentFormDetails?.form) {
      const form = data1.getDependentFormDetails.form

      if (form.isDependent) {
        const sender = form.senderEmail || ''
        const receiver = form.recipientEmails || ''
        const message = form.customMessage || ''
        const link = form.shareableLink || ''
        const fields = form.formsFields || []

        setSenderEmail(sender)
        setReceiverEmail(receiver)
        setCustomMessage(message)
        setFormLinkInput(link)
        setSelectedFields(fields)
        setShowShareForm(true)

        // Save initial data snapshot for change detection
        setInitialFormData({
          senderEmail: sender,
          receiverEmail: receiver,
          customMessage: message,
          formLinkInput: link,
          selectedFields: fields
        })
      }
    }
  }, [data1])

  const handleSaveDependency = async (e: React.FormEvent) => {
    e.preventDefault()
    try {
      const { data } = await AddFormDependency({
        variables: {
          input: {
            currentFormUuid: uuid,
            senderEmail,
            recipientEmails: receiverEmail,
            shareableLink: formLinkInput || botgoUrl,
            customMessage,
            formsFields: selectedFields,
            isDependent: showShareForm
          }
        }
      })
      toast.success('Form dependency saved successfully')
    } catch (err) {
      console.error(err)
      toast.error('Failed to save form dependency')
    }
  }

  const isFormModified = () => {
    return (
      senderEmail !== initialFormData.senderEmail ||
      receiverEmail !== initialFormData.receiverEmail ||
      customMessage !== initialFormData.customMessage ||
      formLinkInput !== initialFormData.formLinkInput ||
      selectedFields.length !== initialFormData.selectedFields.length ||
      selectedFields.some((field, index) => field !== initialFormData.selectedFields[index])
    )
  }

  const formRecord = data?.getAllFormBuilderByBgAccountId?.data?.[0]
  const isPrefillForm = isPrefillDistributionForm(formRecord)
  const formData = formRecord?.formData ?? []
  const allLabels: string[] = formData
    .flat()
    .map((field: any) => field.label)
    .filter(Boolean)

  const openWhatsAppModel = () => {
    setIsWhatsAppModelOpen(true)
  }
  const closeWhatsAppModel = () => {
    setIsWhatsAppModelOpen(false)
  }
  const openModal = () => {
    setIsModalOpen(true)
  }
  const afterOpenModal = () => {
    // subtitle.style.color = '#f00'
  }
  const closeModal = () => {
    setIsModalOpen(false)
  }
  const openQrCodeModal = () => {
    setIsQrCodeModalOpen(true)
  }
  const closeQrCodeModal = () => {
    setIsQrCodeModalOpen(false)
  }
  const openEmailModel = () => {
    setIsEmailModelOpen(true)
  }
  const CloseEmailModel = () => {
    setIsEmailModelOpen(false)
  }
  const customModalStyles = {
    content: {
      top: '50%',
      left: '50%',
      right: 'auto',
      bottom: 'auto',
      marginRight: '-60%',
      transform: 'translate(-40%, -60%)'
    }
  }
  const handleCopyLink = () => {
    if (linkRef.current) {
      linkRef.current.select()
      document.execCommand('copy')
      setIsCopiedLink(true)
      toast.success('Link copied successfully!')
    }
  }
  const handleShareFormModalSettingClick = () => {
    openModal()
  }
  const deploymentEnvironment = process.env.REACT_APP_DEPLOYMENT_ENVIRONMENT as string
  const botgoUrl =
    deploymentEnvironment === 'demo'
      ? `https://forms-demo.globtierinfotech.com/form/botgoforms/${uuid}`
      : `https://forms.globtierinfotech.com/form/botgoforms/${uuid}`

  const handleBack = () => {
    navigate('/automation/process-automation/form-builder')
  }
  const generateQrCode = () => {
    // Update the URL structure to include the formId as a query parameter
    const qrCodeUrl = botgoUrl
    setQrCodeUrl(qrCodeUrl)
    openQrCodeModal()
  }

  const SelectFieldsModal = ({
    isOpen,
    onRequestClose,
    allFields,
    selectedFields,
    setSelectedFields
  }: {
    isOpen: boolean
    onRequestClose: () => void
    allFields: string[]
    selectedFields: string[]
    setSelectedFields: (fields: string[]) => void
  }) => {
    const handleCheckboxChange = (label: string) => {
      if (selectedFields.includes(label)) {
        setSelectedFields(selectedFields.filter((item) => item !== label))
      } else {
        setSelectedFields([...selectedFields, label])
      }
    }

    return (
      <ReactModal
        isOpen={isOpen}
        onRequestClose={onRequestClose}
        contentLabel='Select Fields'
        ariaHideApp={false}
        style={{
          content: {
            top: '50%',
            left: '50%',
            right: 'auto',
            bottom: 'auto',
            transform: 'translate(-50%, -50%)',
            padding: '2rem',
            width: '400px',
            maxHeight: '80vh',
            overflowY: 'auto',
            borderRadius: '12px'
          }
        }}
      >
        <h5 className='mb-3'>Select Fields to Include</h5>
        {allFields.length === 0 && <p>No fields available</p>}
        <div className='mb-3'>
          {allFields.map((label) => (
            <div key={label} className='form-check'>
              <input
                className='form-check-input'
                type='checkbox'
                id={label}
                checked={selectedFields.includes(label)}
                onChange={() => handleCheckboxChange(label)}
              />
              <label className='form-check-label' htmlFor={label}>
                {label}
              </label>
            </div>
          ))}
        </div>
        <button className='btn btn-primary' onClick={onRequestClose}>
          Save Selection
        </button>
      </ReactModal>
    )
  }

  return (
    <section className='row p-4 deployement'>
      <div className='col-12 d-flex flex-column card rounded h-800px'>
        <div className='row justify-content-center'>
          <div className='col-md-12'>
            <div className='card'>
              <div className='card-body'>
                <div className='d-flex align-items-center'>
                  <span
                    role='button'
                    className='mt-0 ms-4 text-hover-primary'
                    style={{ marginRight: '20px' }}
                    onClick={handleBack}
                  >
                    <i className='bi bi-arrow-left text-black' style={{ fontSize: '30px' }}></i>
                  </span>
                  <i className='bi bi-share-fill me-2' style={{ fontSize: '18px' }}></i>
                  <h1 className='h1 lh-lg mb-0'>PUBLISH</h1>
                </div>
                <ul
                  className='nav nav-stretch nav-line-tabs border-transparent flex-nowrap mb-5'
                  style={{ margin: 'auto' }}
                ></ul>
                <h2 className='card-subtitle-underline mb-4 '>
                  {isPrefillForm
                    ? 'Download the Excel template, upload filled data, then share a personalized form to each recipient.'
                    : 'Add your form to your website and share it on social platforms.'}
                </h2>
                {isPrefillForm && (
                  <span className={`badge ${getFormTypeBadgeClass(formRecord)} mb-4`}>
                    {getFormTypeLabel(formRecord)} Form
                  </span>
                )}
                <ul
                  className='nav nav-stretch nav-line-tabs border-transparent flex-nowrap mb-5'
                  style={{ margin: 'auto' }}
                ></ul>

                {isPrefillForm && uuid && <PrefillDistributionPanel formUuid={uuid} />}

                {isPrefillForm && uuid && (
                  <div className='d-flex justify-content-end mb-4'>
                    <Link to={`/automation/table/${uuid}`} className='btn btn-light-primary btn-sm'>
                      <i className='bi bi-table me-2' />
                      View All Submissions
                    </Link>
                  </div>
                )}

                {!isPrefillForm && (
                  <>
                    <div className='row'>
                      <div className='mb-3'>
                        <div className='d-flex align-items-center'>
                          <i
                            className='bi bi-link-45deg mb-2 me-1'
                            style={{ fontSize: '25px' }}
                          ></i>
                          <h3 className='fw-bold mb-3'>DIRECT LINK OF YOUR FORM</h3>
                        </div>
                        <p className='card-subtitle-1'>
                          Your form is securely published and ready to use at this address.
                        </p>
                        <div className='card w-75 border border-black p-7'>
                          <div className='w-100'>
                            <div
                              style={{
                                overflow: 'hidden',
                                pointerEvents: 'all',
                                opacity: '1',
                                height: '205px'
                              }}
                            >
                              <div className='d-flex flex-column'>
                                <div className='d-flex flex-row justify-content-start '>
                                  <span className='fs-4 fw-bold mt-2'>LINK TO SHARE</span>
                                  <button
                                    className={`py-2 px-4 ms-5 fw-bold border border-primary rounded-pill text-primary`}
                                    style={{ backgroundColor: ' #DFF3FF' }}
                                  >
                                    <i
                                      className={`bi ${
                                        selectedAccess === 'private'
                                          ? 'bi-lock-fill'
                                          : 'bi-unlock-fill'
                                      } text-primary`}
                                    ></i>
                                    {selectedAccess === 'private' ? 'Private Form' : 'Public Form'}
                                  </button>
                                  <span
                                    className='text-primary ms-auto'
                                    onClick={handleShareFormModalSettingClick}
                                    role='button'
                                  >
                                    <i className='bi bi-gear-fill text-primary'></i> Settings
                                  </span>
                                  <ReactModal
                                    isOpen={isModalOpen}
                                    onAfterOpen={openModal}
                                    onRequestClose={closeModal}
                                    style={customModalStyles}
                                    contentLabel='Setting '
                                  >
                                    <ShareFormSettingModal closeModal={closeModal} />
                                  </ReactModal>
                                </div>
                                <form>
                                  <fieldset>
                                    <div className='mb-3 mt-6'>
                                      <input
                                        type='text'
                                        id='disabledTextInput'
                                        className='form-control'
                                        value={botgoUrl}
                                        ref={linkRef}
                                        readOnly
                                        style={{
                                          background: '#F5F5FA',
                                          border: '1px solid #CAD3E3'
                                        }}
                                      />
                                    </div>
                                  </fieldset>
                                </form>
                              </div>
                            </div>
                            <div className='d-flex justify-content-end'>
                              <button
                                onClick={handleCopyLink}
                                className='border fs-4 p-2 rounded-2 text-white'
                                style={{ backgroundColor: 'rgba(100,178,0)', opacity: '1' }}
                              >
                                <i
                                  className={`me-1 text-white ${
                                    isCopiedLink ? 'fas fa-check' : 'fas fa-copy'
                                  }`}
                                />
                                {isCopiedLink ? 'Copied' : 'Copy'}
                              </button>
                              {/* Your additional button for Preview */}
                              <button
                                className=' ms-4 border fs-4 p-2 rounded-2 text-white'
                                style={{ backgroundColor: 'rgb(65, 112, 226)', opacity: '1' }}
                              >
                                <i
                                  className='bi bi-link-45deg  me-1 text-white'
                                  style={{
                                    marginRight: '4px',
                                    color: 'black'
                                  }}
                                />
                                <a
                                  className=' me-1 text-white'
                                  href={botgoUrl}
                                  target='_blank'
                                  rel='noreferrer'
                                  style={{
                                    color: 'rgb(85, 83, 183)',
                                    fontSize: '15px'
                                  }}
                                >
                                  Preview
                                </a>
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    {/* Toggle for Share another form after submission via Email */}
                    <div className='card w-75 border border-black mt-4'>
                      <div className='card-body'>
                        <div className='form-check form-switch mb-3'>
                          <input
                            className='form-check-input'
                            type='checkbox'
                            id='shareAfterSubmitToggle'
                            checked={showShareForm}
                            onChange={async () => {
                              const newValue = !showShareForm
                              setShowShareForm(newValue)

                              if (!newValue) {
                                try {
                                  await AddFormDependency({
                                    variables: {
                                      input: {
                                        currentFormUuid: uuid,
                                        senderEmail: '',
                                        recipientEmails: '',
                                        shareableLink: '',
                                        customMessage: '',
                                        formsFields: [],
                                        isDependent: false
                                      }
                                    }
                                  })
                                  toast.success('Form dependency removed successfully')
                                } catch (err) {
                                  console.error(err)
                                  toast.error('Failed to remove form dependency')
                                }
                              }
                            }}
                          />
                          <label
                            className='form-check-label fw-bold'
                            htmlFor='shareAfterSubmitToggle'
                          >
                            Share another form after submission via email
                          </label>
                        </div>

                        {showShareForm && (
                          <form onSubmit={handleSaveDependency}>
                            <div className='mb-3'>
                              <label className='form-label fw-semibold'>Sender's Email</label>
                              <input
                                type='email'
                                className='form-control'
                                placeholder='sender@example.com'
                                required
                                value={senderEmail}
                                onChange={(e) => setSenderEmail(e.target.value)}
                              />
                            </div>

                            <div className='mb-3'>
                              <label className='form-label fw-semibold'>Receiver's Email</label>
                              <input
                                type='email'
                                className='form-control'
                                placeholder='receiver@example.com'
                                required
                                value={receiverEmail}
                                onChange={(e) => setReceiverEmail(e.target.value)}
                              />
                            </div>

                            <div className='mb-3'>
                              <label className='form-label fw-semibold'>Custom Message</label>
                              <textarea
                                className='form-control'
                                rows={3}
                                placeholder='Write a message...'
                                value={customMessage}
                                onChange={(e) => setCustomMessage(e.target.value)}
                              ></textarea>
                            </div>

                            <div className='mb-3'>
                              <label className='form-label fw-semibold'>Form Link</label>
                              <input
                                type='text'
                                className='form-control'
                                placeholder={`For example: ${botgoUrl}`}
                                value={formLinkInput}
                                onChange={(e) => setFormLinkInput(e.target.value)}
                              />
                              <small className='form-text text-muted'>
                                Provide the link of the form that should be sent via email after
                                this form is submitted.
                              </small>
                            </div>

                            <div className='mb-3'>
                              <label className='form-label fw-semibold'>
                                Form Fields (comma separated)
                              </label>
                              <input
                                type='text'
                                className='form-control'
                                placeholder='name, email, phone'
                                value={selectedFields.join(', ')}
                                readOnly
                                onClick={() => setIsSelectFieldModalOpen(true)}
                              />
                            </div>

                            <button
                              type='submit'
                              className='btn btn-primary'
                              disabled={!isFormModified()}
                            >
                              Save
                            </button>
                          </form>
                        )}
                      </div>
                    </div>

                    <div className='card w-75 border border-black mt-4'>
                      <div className='card-body'>
                        <h5 className='card-title'> SHARE FORM </h5>
                        <p className='card-text'>
                          Share your form link in various social posts and through email.
                        </p>
                        <div className='d-flex'>
                          <button className='btn me-n8' onClick={openWhatsAppModel}>
                            <img
                              alt='Share on Whatsapp'
                              className='social-link-icon'
                              src='https://chatbot-project.s3.ap-south-1.amazonaws.com/botgo/assets/images/whatsapp.jpeg'
                              style={{ height: '50px' }}
                            />
                          </button>
                          <button className='btn me-n8' onClick={openEmailModel}>
                            <img
                              alt='Share on Email'
                              className='social-link-icon'
                              src='https://cdn-icons-png.flaticon.com/512/552/552486.png'
                              style={{ height: '40px' }}
                            />
                          </button>
                          <button className='btn me-n8' onClick={generateQrCode}>
                            <img
                              alt='QR Code Generator'
                              className='social-link-icon'
                              src='https://upload.wikimedia.org/wikipedia/commons/1/11/Qr_code_QR-Code-Generator.png'
                              style={{ height: '40px' }}
                            />
                          </button>
                        </div>
                      </div>
                      {/* QR Code Generator Modal */}
                      <ReactModal
                        isOpen={isQrCodeModalOpen}
                        onAfterOpen={() => {}}
                        onRequestClose={closeQrCodeModal}
                        style={customModalStyles}
                        contentLabel='Qr Code Generate '
                      >
                        <QrcodeGenerateModel
                          closeModal={closeQrCodeModal}
                          qrCodeValue={qrCodeUrl}
                        />
                      </ReactModal>
                    </div>
                    {/* WhatsApp Share Model */}
                    <ReactModal
                      isOpen={isWhatsAppModelOpen}
                      onAfterOpen={() => {}}
                      onRequestClose={closeWhatsAppModel}
                      style={customModalStyles}
                      contentLabel='WhatsApp Share Model'
                    >
                      <ShareOnWhatsAppModel closeModal={closeWhatsAppModel} />
                    </ReactModal>
                    <ReactModal
                      isOpen={isEmailModelOpen}
                      onAfterOpen={() => {}}
                      onRequestClose={CloseEmailModel}
                      style={customModalStyles}
                      contentLabel='Email Model'
                    >
                      <ShareViaEmailModel
                        closeModal={CloseEmailModel}
                        botgoUrl={botgoUrl}
                        formId={uuid}
                      />
                    </ReactModal>
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
      {isCopiedLink && (
        <div
          className='toast'
          style={{ position: 'fixed', top: '70px', right: '10px', zIndex: 9999 }}
        >
          <div className='toast-header'>
            {isCopiedLink ? 'Link Copy Success' : 'Link Copy Error'}
            <button type='button' className='btn-close' onClick={() => setIsCopiedLink(false)} />
          </div>
          <div className='toast-body'>
            {isCopiedLink ? 'Link copied successfully!' : 'Sorry! Unexpected Error copying link.'}
          </div>
        </div>
      )}
      <SelectFieldsModal
        isOpen={isSelectFieldModalOpen}
        onRequestClose={() => setIsSelectFieldModalOpen(false)}
        allFields={allLabels}
        selectedFields={selectedFields}
        setSelectedFields={setSelectedFields}
      />

      <style>
        {`
        .form-check-input:checked {
          background-color: #0d6efd;
          border-color: #0d6efd;
        }
        .form-control {
          border-radius: 8px;
        }
        .form-check-label {
          cursor: pointer;
        }
        .form-check {
          margin-bottom: 8px;
        }
      `}
      </style>
    </section>
  )
}
export default ShareForm
